import * as React from "react"
import { positionRight } from "@reach/popover"
import { MdDeleteForever, MdMoreVert, MdEdit } from "react-icons/md"
import {
  Button,
  DropdownMenu,
  DropdownMenuPopover,
  DropdownMenuItemsLowLevel,
  DropdownMenuItem,
  DropdownMenuButton,
} from "gatsby-interface"
import {
  showOnlyOnMobileCss,
  hideOnMobileCss,
} from "@modules/ui/utils/responsive"

const cdnIntegrationActions = {
  display: "flex",
  flex: 1,
  justifyContent: "space-around",
}

type LogDrainIntegrationDropdownProps = {
  onEdit: () => void
  onDelete: () => void
  props?: any
}

export function LogDrainIntegrationDropdown({
  onEdit,
  onDelete,
  ...props
}: LogDrainIntegrationDropdownProps) {
  return (
    <React.Fragment>
      <div css={theme => [showOnlyOnMobileCss(theme), cdnIntegrationActions]}>
        <Button variant="GHOST" onClick={onEdit} leftIcon={<MdEdit />}>
          Edit
        </Button>

        <Button
          variant="GHOST"
          tone="DANGER"
          onClick={onDelete}
          leftIcon={<MdDeleteForever />}
        >
          Delete
        </Button>
      </div>

      <DropdownMenu>
        <Button
          {...props}
          ButtonComponent={DropdownMenuButton}
          data-cy={`edit-deploy-target-button`}
          size="L"
          variant="GHOST"
          tone="BRAND"
          css={theme => [
            {
              gridColumn: `3 / 4`,
              gridRow: `1 / 2`,
              justifySelf: `end`,
            },
            hideOnMobileCss(theme),
          ]}
        >
          <MdMoreVert />
        </Button>
        <DropdownMenuPopover position={positionRight}>
          <DropdownMenuItemsLowLevel size="MAX_CONTENT">
            <DropdownMenuItem onSelect={onEdit} Icon={MdEdit}>
              Edit
            </DropdownMenuItem>
            <DropdownMenuItem
              onSelect={onDelete}
              Icon={MdDeleteForever}
              tone="CRITICAL"
            >
              Delete
            </DropdownMenuItem>
          </DropdownMenuItemsLowLevel>
        </DropdownMenuPopover>
      </DropdownMenu>
    </React.Fragment>
  )
}
